import postWithToken from './base/post-with-token'

const customerShare = (customerId, email) => {
    return postWithToken(`/customer/${customerId}/share`)({
        email,
    })
}

export default customerShare